module.exports = __webpack_public_path__ + "static/media/masterCard.2e78057d.svg";